/* eslint-disable camelcase */
import { useState } from 'react';
import { Typography, Fab, Stack, MenuItem, Box, IconButton } from '@mui/material';
import Iconify from './Iconify';
import Image from './Image';
import { useSelector } from '../redux/store';
import useLocales from '../hooks/useLocales';
import CustomModal from './CustomModal';

export default function SocialFab() {
  const { translate } = useLocales();

  const { siteSettings } = useSelector((x) => x.lookup);
  const [open, setOpen] = useState(false);
  const [hidden, setHidden] = useState(false);

  const openSocial = (link) => {
    setOpen(false);
    window.open(
      link,
      '_blank'
      // 'noopener noreferrer'
    );
  };

  const {
    config_facebook,
    config_instagram,
    config_line,
    config_messenger,
    config_telegram,
    config_twitter,
    config_viber,
    config_wechat,
    config_whatsapp,
    config_youtube,
  } = siteSettings || {};

  const socials = [
    { name: 'LINE', config: config_line, src: require('../assets/social/line.png') },
    { name: 'Facebook', config: config_facebook, src: require('../assets/social/fb.png') },
    { name: 'Instagram', config: config_instagram, src: require('../assets/social/instagram.png') },
    { name: 'Messenger', config: config_messenger, src: require('../assets/social/messenger.png') },
    { name: 'Telegram', config: config_telegram, src: require('../assets/social/telegram.png') },
    { name: 'Twitter', config: config_twitter, src: require('../assets/social/twitter.png') },
    { name: 'Viber', config: config_viber, src: require('../assets/social/viber.png') },
    { name: 'WeChat', config: config_wechat, src: require('../assets/social/wechat.png') },
    { name: 'WhatsApp', config: config_whatsapp, src: require('../assets/social/wa.png') },
    { name: 'YouTube', config: config_youtube, src: require('../assets/social/yt.png') },
  ];

  return (
    <>
      {!hidden && (
        <Box sx={{ position: 'fixed', top: { xs: '75%', sm: '75%', md: '80%' }, right: 5, zIndex: 1301 }}>
          <Box sx={{ position: 'relative' }}>
            <Fab
              color="primary"
              onClick={() => setOpen(true)}
              sx={{
                background: 'linear-gradient(135deg, #0095E9, #3F00C5)',
                color: '#fff',
                boxShadow: 4,
              }}
            >
              <Iconify icon="mdi:share-variant" sx={{ fontSize: '2rem' }} />
            </Fab>
            <IconButton onClick={() => setHidden(true)} sx={{ p: 0, m: 0, marginTop: '-75px', marginLeft: '-10px' }}>
              <Iconify icon="carbon:close-filled" sx={{ color: '#F0C335', fontSize: '20px' }} />
            </IconButton>
          </Box>
        </Box>
      )}

      <CustomModal maxWidth={'xs'} open={open} onClose={() => setOpen(false)} title={translate('follow_us')}>
        <Stack sx={{ p: 1 }}>
          {socials.map((s, i) =>
            s.config ? (
              <MenuItem key={i} onClick={() => openSocial(s.config)} sx={{ cursor: 'pointer' }}>
                <Image src={s.src} sx={{ width: '43px', height: '43px' }} />
                <Typography sx={{ ml: 1 }}>{s.name}</Typography>
              </MenuItem>
            ) : null
          )}
        </Stack>
      </CustomModal>
    </>
  );
}
